import React, { useState, useRef, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const DEFAULT_MUSIC = 'https://cdn.pixabay.com/audio/2024/11/28/audio_3a8ff4e498.mp3';

export default function MusicPlayer() {
  const { pathname } = useLocation();
  const [playing, setPlaying] = useState(false);
  const [musicUrl, setMusicUrl] = useState(DEFAULT_MUSIC);
  const audioRef = useRef(null);

  useEffect(() => {
    // Fetch admin-configured music URL
    axios.get(`${BACKEND_URL}/api/site-settings/music`)
      .then(res => {
        if (res.data.music_url) setMusicUrl(res.data.music_url);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = '';
    }
    const audio = new Audio(musicUrl);
    audio.loop = true;
    audio.volume = 0.45;
    audio.preload = 'none';
    audioRef.current = audio;

    return () => {
      audio.pause();
      audio.src = '';
    };
  }, [musicUrl]);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(() => {});
    }
    setPlaying(!playing);
  };

  if (pathname.startsWith('/easer') || pathname.startsWith('/admin') || pathname.startsWith('/client')) return null;

  return (
    <button
      onClick={toggle}
      className={`fixed bottom-[72px] md:bottom-5 left-5 z-50 w-11 h-11 rounded-full flex items-center justify-center shadow-lg border transition-all duration-300 ${
        playing
          ? 'bg-[hsl(var(--primary))] border-[hsl(var(--primary))] text-white'
          : 'bg-card border-border text-muted-foreground hover:border-[hsl(var(--primary))] hover:text-[hsl(var(--primary))]'
      }`}
      title={playing ? 'Couper la musique' : 'Activer la musique'}
      aria-label={playing ? 'Couper la musique' : 'Activer la musique'}
      data-testid="music-toggle"
    >
      {playing ? (
        <>
          <Volume2 className="h-5 w-5" />
          <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-green-400 animate-pulse" />
        </>
      ) : (
        <VolumeX className="h-5 w-5" />
      )}
    </button>
  );
}
